import type { DateRange } from 'react-day-picker';
import { Calendar } from '@/components/atoms/calendar';
import { DataTableDateRangeLabel } from './DataTableDateRangeLabel';

interface DataTableDateRangeFieldProps {
  range: DateRange | undefined;
  onSelect: (range: DateRange | undefined) => void;
}

export function DataTableDateRangeField({ range, onSelect }: DataTableDateRangeFieldProps) {
  return (
    <>
      {range?.from || range?.to ? (
        <p className="mb-1 text-xs text-muted-foreground">
          <DataTableDateRangeLabel range={range} />
        </p>
      ) : null}
      <div className="rounded-md border border-border/50">
        <Calendar
          mode="range"
          selected={range}
          onSelect={onSelect}
          numberOfMonths={1}
          className="relative"
        />
      </div>
    </>
  );
}
